import { useMemo } from 'react';

import { PersonAdd } from '@mui/icons-material';
import { ActionItemKeys } from '@uplift/api';
import { settingsRoute } from '@uplift/constants';
import { trackToDoCTA, useActionItem, useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { LinkDashboardActionItem } from '@uplift/ui-v2';

export const useEmergencyContactActionItem = () => {
  const l10n = useL10n();
  const emergencyContactData = useActionItem(ActionItemKeys.CLIENT_EMERGENCY_CONTACT);

  const actionItem = useMemo(() => {
    if (!emergencyContactData?.name || !emergencyContactData?.phone || !emergencyContactData?.relationship) {
      return (
        <LinkDashboardActionItem
          title={l10n.dashboard.actionItems.emergencyContact.title}
          color="warning"
          icon={<PersonAdd />}
          actionText="Add"
          link={settingsRoute.createLink(null, { edit: 'emergencyContact' })}
          onClick={() => trackToDoCTA({
            toDoType: ActionItemKeys.CLIENT_EMERGENCY_CONTACT,
            userType: UserRole.patient
          })}
        />
      );
    }

    return null;
  }, [ emergencyContactData?.name, emergencyContactData?.phone, emergencyContactData?.relationship, l10n.dashboard.actionItems.emergencyContact.title ]);

  return {
    isLoading: emergencyContactData.isLoading,
    actionItem
  };
};
